import script from "./WelcomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomePage.vue?vue&type=script&setup=true&lang=js"

import "./WelcomePage.vue?vue&type=style&index=0&id=6090f8af&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hairwizard/hairwizard/hwappointments/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6090f8af"]])

export default __exports__